import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAllLiveClasses,
  createLiveClassApi,
  getStaticLiveClassApi,
} from "../../apis/scheduleAndTimetable";

export const getAllClasses = createAsyncThunk(
  "scheduled-class/getAll",
  async () => {
    const response = await getAllLiveClasses();
    return response.data.data.Completed;
  }
);

export const createLiveclass = createAsyncThunk(
  "scheduled-class/create",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await createLiveClassApi(formData);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Something went wrong");
    }
  }
);

export const getAllStaticLiveClasses = createAsyncThunk(
  "scheduled-class/static-data", // static data for the  live class api
  async () => {
    const response = await getStaticLiveClassApi();
    return response.data;
  }
);
const classScheduleSlice = createSlice({
  name: "classes",
  initialState: {
    classes: [],
    staticData: {
      subjects: [],
      chapters: [],
      topics: [],
      classLevels: [],
      classTypes: [],
      years: [],
      courseYear: [],
    },
    status: "idle",
    error: null,
  },
  reducers: {
    reset: (state) => {
      state.classes = [];
      state.staticData = {
        subjects: [],
        chapters: [],
        topics: [],
        classLevels: [],
        classTypes: [],
        years: [],
        courseYear: [],
      };
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllClasses.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAllClasses.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.classes = action.payload;
      })
      .addCase(getAllClasses.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      // create class
      .addCase(createLiveclass.pending, (state) => {
        state.status = "loading";
      })
      .addCase(createLiveclass.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.classes.push(action.payload); // Add new class
      })
      .addCase(createLiveclass.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      // static classes ---
      .addCase(getAllStaticLiveClasses.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAllStaticLiveClasses.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.staticData = {
          subjects: action?.payload?.subjects || [],

          chapters: action.payload.chapters || [],
          topics: action.payload.topics || [],
          classLevels: action.payload.classLevels || [],
          classTypes: action.payload.classTypes || [],
          years: action.payload.years || [],
          courseYear: action.payload.courseYear || [],
        };
      })
      .addCase(getAllStaticLiveClasses.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default classScheduleSlice.reducer;
